module.exports = __webpack_public_path__ + "img/facebook-logo.a79cba1e.svg";